import React from 'react';

import partnerCrewConcept from '../../../main/assets/images/skydive/partner-logo-crewConcept.webp';
import partnerDroneLegends from '../../../main/assets/images/skydive/partner-logo-droneLegends.webp';
import partnerMilestoneC from '../../../main/assets/images/skydive/partner-logo-milestonec.webp';
import partnerUsdra from '../../../main/assets/images/skydive/partner-logo-usdra.webp';
import partnerWhoopers from '../../../main/assets/images/skydive/partner-logo-whoopers.webp';

export const DroneSoccerPartners = () => {
  return (
    <div className="soccer-partners-section">
      <h2 className="soccer-partners-title">Partners</h2>
      <div className="soccer-partners-logos-container">
        <img
          src={partnerUsdra}
          alt="Unified Scholastic Drone Racing Association (USDRA) Logo"
          className="soccer-partners-logo"
        />
        <img
          src={partnerCrewConcept}
          alt="CrewConcept Drone Lab Logo"
          className="soccer-partners-logo"
        />
        <img
          src={partnerDroneLegends}
          alt="Drone Legends Logo"
          className="soccer-partners-logo"
        />
        <img
          src={partnerMilestoneC}
          alt="Milestone C Logo"
          className="soccer-partners-logo"
        />
        <img
          src={partnerWhoopers}
          alt="Wednesday Whoppers Logo"
          className="soccer-partners-logo"
        />
      </div>
    </div>
  );
};
